import React, {useEffect, useContext, useState} from "react";
import ActionsContext from "common/ActionsContext";
import {
  getVersion,
  getSystemName,
  getHardwareId,
  getStartTime,
  getSerialNumber,
  getLicense,
} from "./utils";

const Information = ({ name, value, link }) => {
  const classNameValue = `font-bold db-counters${
    link ? " hyperlink-text-nocolor" : ""
  }`;
  const handleClick = () => {
    if (!link) {
      return;
    }
    globalNavigate(link);
  };

  return (
    <>
      <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
        <div>{name}</div>
      </div>
      <div className="col-lg-8 col-md-8 col-sm-8 col-xs-8">
        <div id="dbSysName" className={classNameValue} onClick={handleClick}>
          {value}
        </div>
      </div>
      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-b-5"></div>
    </>
  );
};

const DashboardInformation = ({ systemDate }) => {
  const actions = useContext(ActionsContext);
  const [hardwareId, setHardwareId] = useState("unknown");
  const [systemName, setSystemName] = useState("unknown");
  const [version, setVersion] = useState("unknown");
  const [startTime, setStartTime] = useState("unknown");
  const [serialNumber, setSerialNumber] = useState("n/a");
  const [license, setLicense] = useState(["n/a", "n/a"]);

  const loadStatics = () => {
    const setters = {
      hardwareId: setHardwareId,
      systemName: setSystemName,
      version: setVersion,
      startTime: setStartTime,
      license: setLicense,
      serialNumber: setSerialNumber,
    };
  
    const dataToFetch = {
      version: getVersion,
      systemName: getSystemName,
      hardwareId: getHardwareId,
      startTime: getStartTime,
      serialNumber: getSerialNumber,
      license: getLicense,
    };
  
    Object.entries(dataToFetch).forEach(([key, fetcher]) => {
      fetcher()
        .then((value) => {
          if (setters[key]) {
            setters[key](value);
          }
        })
        .catch((error) => {
          console.error(`Error fetching dashboard data for '${key}':`, error);
        });
    });
  };

  useEffect(() => {
    loadStatics();
    return actions.recv("do-load", loadStatics);
  }, []);

  return (
    <div className="card">
      <div className="body dashboard-information">
        <div className="row">
          <Information name="System Name" value={systemName} />
          <Information name="BQN Release" value={version} link="viewSoftware" />
          <Information name="Hardware ID" value={hardwareId} />
          <Information name="Start Time" value={startTime} />
          <Information name="Serial Number" value={serialNumber} />
          <Information name="System Time" value={systemDate} />
          <Information
            name="License Limit"
            value={license[0]}
            link="viewLicense"
          />
          <Information
            name="License Expiration"
            value={license[1]}
            link="viewLicense"
          />
        </div>
      </div>
    </div>
  );
};

export default DashboardInformation;
